import { z } from 'zod';

export const FacultyStatusSchema = z.enum([
  'invited',
  'active',
  'on_leave_medical',
  'on_leave_maternity',
  'on_leave_sabbatical',
  'on_leave_other',
  'inactive',
  'substitute',
  'temporary',
  'terminated',
]);
export type FacultyStatus = z.infer<typeof FacultyStatusSchema>;

export const DivisionAssignmentTypeSchema = z.enum(['primary', 'secondary']);
export type DivisionAssignmentType = z.infer<typeof DivisionAssignmentTypeSchema>;

export const TeachingRoleSchema = z.enum(['lead', 'assistant', 'substitute']);
export type TeachingRole = z.infer<typeof TeachingRoleSchema>;

export const ScheduleDaySchema = z.enum(['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']);
export type ScheduleDay = z.infer<typeof ScheduleDaySchema>;

export const NoteVisibilitySchema = z.enum(['internal', 'shared']);
export type NoteVisibility = z.infer<typeof NoteVisibilitySchema>;

export const TagScopeSchema = z.enum(['internal', 'shared']);
export type TagScope = z.infer<typeof TagScopeSchema>;

export const CommunicationChannelSchema = z.enum(['email', 'sms', 'in_app', 'phone']);
export type CommunicationChannel = z.infer<typeof CommunicationChannelSchema>;

export const CommunicationStatusSchema = z.enum(['queued', 'sent', 'failed']);
export type CommunicationStatus = z.infer<typeof CommunicationStatusSchema>;
